import React from 'react'
import { SystemLogo as UiKitSystemLogo, SystemLogoType } from '@elamajs/ui-kit'

import targetGroupIcon from './assets/target-group.svg'
import wowBloggerIcon from './assets/wow-blogger.svg'
import twoGisIcon from './assets/two-gis.svg'
import oohdeskDspIcon from './assets/oohdesk-dsp.svg'
import googleInternalIcon from './assets/google_internal.svg'
import telegramAdsIcon from './assets/telegramAds.svg'
import tiktokAdsIcon from './assets/tiktok_ads.svg'
import marketologPro from './assets/marketolog-pro.svg'
import vkDzen from './assets/vk_dzen.svg'
import sberAds from './assets/sberAds.svg'
import people from './assets/people.svg'
import avito from './assets/avito.svg'
import gnezdo from './assets/gnezdo.svg'
import wildberries from './assets/wildberries.svg'
import ozon from './assets/ozon.svg'
import yadzen from './assets/yadzen.svg'
import samba from './assets/samba.svg'

/* eslint-disable @typescript-eslint/camelcase */
export const SYSTEM_CODE = {
  direct_common: 'direct_common',
  i_digital: 'i_digital',
  seo_wizard: 'seo_wizard',
  yandex_network: 'yandex_network',
  google_internal: 'google_internal',
  target_group: 'target_group',
  tiktok_ads: 'tiktok_ads',
  avito: 'avito',
  yadzen: 'yadzen',
  yanavigator: 'yanavigator',
  yaspravochnik: 'yaspravochnik',
  calltouch: 'calltouch',
  get_radio: 'get_radio',
  telega_in: 'telega_in',
  telegramAds: 'telegramAds',
  wow_blogger: 'wow_blogger',
  two_gis: 'two_gis',
  oohdesk_dsp: 'oohdesk_dsp',
  marketolog_pro: 'marketolog_pro',
  vk_dzen: 'vkDzen',
  vk_adblogger: 'vk_adblogger',
  sber_ads: 'sber_ads',
  avitoAds: 'avitoAds',
  gnezdo: 'gnezdo',
  wildberries: 'wildberries',
  ozon: 'ozon',
  samba: 'samba'
}
/* eslint-enable @typescript-eslint/camelcase */

export const SYSTEM_LOGO: Record<string, SystemLogoType> = {
  [SYSTEM_CODE.direct_common]: 'yandex-direct',
  [SYSTEM_CODE.yandex_network]: 'yandex-direct',
  [SYSTEM_CODE.google_internal]: 'google-ads',
  [SYSTEM_CODE.tiktok_ads]: 'tiktok',
  [SYSTEM_CODE.avito]: 'avito',
  [SYSTEM_CODE.avitoAds]: 'avito',
  [SYSTEM_CODE.yadzen]: 'yandex-promo',
  [SYSTEM_CODE.yanavigator]: 'yandex-navigator',
  [SYSTEM_CODE.yaspravochnik]: 'yandex-business',
  [SYSTEM_CODE.calltouch]: 'calltouch',
  [SYSTEM_CODE.get_radio]: 'getradio',
  [SYSTEM_CODE.telega_in]: 'telega-in',
  [SYSTEM_CODE.telegramAds]: 'telegram-ads',
  [SYSTEM_CODE.i_digital]: 'i-digital-direct',
  [SYSTEM_CODE.seo_wizard]: 'seoWizard'
}

export const SYSTEM_ICON = {
  [SYSTEM_CODE.target_group]: targetGroupIcon,
  [SYSTEM_CODE.wow_blogger]: wowBloggerIcon,
  [SYSTEM_CODE.two_gis]: twoGisIcon,
  [SYSTEM_CODE.oohdesk_dsp]: oohdeskDspIcon,
  [SYSTEM_CODE.telegramAds]: telegramAdsIcon,
  [SYSTEM_CODE.google_internal]: googleInternalIcon,
  [SYSTEM_CODE.tiktok_ads]: tiktokAdsIcon,
  [SYSTEM_CODE.marketolog_pro]: marketologPro,
  [SYSTEM_CODE.vk_dzen]: vkDzen,
  [SYSTEM_CODE.sber_ads]: sberAds,
  [SYSTEM_CODE.vk_adblogger]: people,
  [SYSTEM_CODE.wildberries]: wildberries,
  [SYSTEM_CODE.ozon]: ozon,
  [SYSTEM_CODE.gnezdo]: gnezdo,
  [SYSTEM_CODE.avitoAds]: avito,
  [SYSTEM_CODE.yadzen]: yadzen,
  [SYSTEM_CODE.samba]: samba
}

export const NO_REWARD_SYSTEM_LIST = [
  SYSTEM_CODE.google_internal,
  SYSTEM_CODE.tiktok_ads,
  SYSTEM_CODE.i_digital,
  SYSTEM_CODE.seo_wizard,
  SYSTEM_CODE.marketolog_pro,
  SYSTEM_CODE.samba
]

type SystemLogoProps = {
  systemCode: string
  systemName: string
}

export const SystemLogo: React.FC<SystemLogoProps> = ({ systemCode, systemName }) => {
  const icon = SYSTEM_ICON[systemCode]

  if (icon) {
    return <img width="20" height="20" src={icon} alt={`${systemName} icon`} />
  }

  const logo = SYSTEM_LOGO[systemCode] || 'placeholder'

  return <UiKitSystemLogo size="p-m" logo={logo} />
}
